import styles from './styles.module.css';
import threePodGiff from '../../assets/gif/three_pods_loader.gif';

export function LeaderboardLoadingState() {
    return (
        <div className={styles.errorContainer}>
            <img className={styles.loadingErrorImage} alt="Loader" src={threePodGiff} />
        </div>
    )
}